var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.ready)?_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(!_vm.ready),expression:"!ready"}],staticClass:"page-loading",attrs:{"element-loading-text":"拼命加载中"}}):_c('div',[_vm._v(_vm._s(_vm.data.x))])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-97e60b8c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Sample.vue
// module id = null
// module chunks = 